module.exports = __webpack_public_path__ + "img/brands.37cd6c22.svg";